
import * as React from 'react'
import { Text, View, ScrollView, TouchableOpacity } from 'react-native'
import { useTheme } from '@react-navigation/native'
import Modal from 'react-navigation-modal'
import Axios from 'axios'
import AsyncStorage from '@react-native-async-storage/async-storage'

export default function ModalMerchant({ navigation, route }) {
    const { colors } = useTheme()
    const [list_merchant, setListMerchant] = React.useState([])

    React.useEffect(() => {
        if (route.params?.list_merchant) {
            setListMerchant(route.params?.list_merchant)
        }
    }, [route.params?.list_merchant])

    const changeMerchant = async (merchant) => {
        await AsyncStorage.setItem('merchant', JSON.stringify(merchant))
        Axios.defaults.baseURL = merchant.url
        Axios.defaults.headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': merchant.token_type + ' ' + merchant.access_token,
            'partnerId': merchant?.partner_id
        }
        navigation.reset({ index: 0, routes: [{ name: 'Home' }] })
    }

    const logout = async () => {
        Axios.defaults.baseURL = 'https://api.boc.vungtau.havaz.vn'
        // Axios.defaults.baseURL = 'https://dev.api.boc.vungtau.havaz.vn/'

        Axios.defaults.headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
        await AsyncStorage.clear()
        navigation.replace('Login')
    }

    return (
        <Modal style={{ top: list_merchant.length > 1 ? '22%' : '35%', backgroundColor: 'transparent', paddingHorizontal: 0, paddingVertical: 0 }}>
            <View style={{ backgroundColor: colors.background, paddingHorizontal: 30, paddingVertical: 20, borderRadius: 10 }}>
                {
                    list_merchant && list_merchant.length > 1 ? <>
                        <Text style={{ textAlign: 'center', fontSize: 20, fontFamily: 'Nunito_700Bold', color: colors.text, marginBottom: 10 }}>
                            Xin mời chọn đơn vị{'\n'}muốn xem dữ liệu</Text>
                        {
                            list_merchant && list_merchant.map((item, idx) => {
                                return <TouchableOpacity key={idx}
                                    style={{
                                        width: 260, backgroundColor: 'white', borderRadius: 10, height: 58,
                                        justifyContent: 'center', alignItems: 'center', marginVertical: 10
                                    }} onPress={() => changeMerchant(item)}>
                                    <Text style={{ fontSize: 18, color: colors.text, fontFamily: 'Nunito_700Bold' }}>{item.title}</Text>
                                </TouchableOpacity>
                            })
                        }
                    </> : <Text style={{ textAlign: 'center', fontSize: 18, fontFamily: 'Nunito_700Bold', color: colors.text, marginBottom: 10 }}>
                        Bạn có muốn đăng xuất {'\n'}khỏi hệ thống không?</Text>
                }
            </View>

            <TouchableOpacity
                style={{
                    width: '100%', backgroundColor: 'white', borderRadius: 10, height: 58,
                    justifyContent: 'center', alignItems: 'center', marginVertical: 10
                }} onPress={logout}>
                <Text style={{ fontSize: 18, color: '#FF6F6F', fontFamily: 'Nunito_700Bold' }}>Đăng xuất</Text>
            </TouchableOpacity>
        </Modal>
    );
}